<template>
    <div class="report-overview">
        <div class="module-item-style report-filter-container">
            <el-date-picker
                    v-model="selectTime"
                    type="daterange"
                    @change="timeSelect"
                    :picker-options="pickerOptions"
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
            >
            </el-date-picker>
            <div class="date-detail-filter">
                <div class="date-item" :class="chooseDate == index ? 'date-actived' : ''"
                     v-for="(item, index) in dateOptions"
                     :key="index" @click="chooseTime(index,item.value)">{{item
                    .name}}
                </div>
            </div>
            <div class="report-filter-top-button">
                <div class="wl-btn" @click="exportData">导出当前数据</div>
            </div>
        </div>
        <div class="report-total-analyze">
            <div class="report-total-analyze-item publicBg">
                <div class="total-analyze-item-icon">
                    <svg-icon icon-class="reportVisitor"></svg-icon>
                </div>
                <div class="total-analyze-item-desc">
                    <p class="desc-title">访客量
                        <span class="analyze-count">{{totalAnalyze.visitor}}</span></p>
                </div>
            </div>
            <div class="report-total-analyze-item publicBg">
                <div class="total-analyze-item-icon">
                    <svg-icon icon-class="reportChat"></svg-icon>
                </div>
                <div class="total-analyze-item-desc">
                    <p class="desc-title">会话量<span class="analyze-count">{{totalAnalyze.call}}</span></p>
                </div>
            </div>
            <div class="report-total-analyze-item publicBg">
                <div class="total-analyze-item-icon">
                    <svg-icon icon-class="reportLeaveMsg"></svg-icon>
                </div>
                <div class="total-analyze-item-desc">
                    <p class="desc-title">留言量<span class="analyze-count">{{totalAnalyze.leave}}</span></p>
                </div>
            </div>
            <div class="report-total-analyze-item publicBg">
                <div class="total-analyze-item-icon">
                    <svg-icon icon-class="reportReply"></svg-icon>
                </div>
                <div class="total-analyze-item-desc">
                    <p class="desc-title">未回复会话量<span class="analyze-count">{{totalAnalyze.uncall}}</span>
                    </p>
                </div>
            </div>
            <div class="report-total-analyze-item publicBg">
                <div class="total-analyze-item-icon">
                    <svg-icon icon-class="reportChatTime"></svg-icon>
                </div>
                <div class="total-analyze-item-desc">
                    <p class="desc-title">平均对话时长<span class="analyze-count">{{totalAnalyze
                        .avg_time}}</span>
                    </p>
                </div>
            </div>
        </div>

        <div class="module-item-style">
            <div class="module-item-title-border-left">
                在线服务数据趋势
                <el-popover
                        placement="right"
                        width="400"
                        style="margin-left: 5px;vertical-align: middle;"
                        trigger="hover">
                    <div style="font-size: 12px;color: #333;">默认为今日截止当前更新时间，不同时段的会话量、未回复量、留言量和访客数量统计</div>
                    <div style="font-size: 12px;color: #333;">按条件筛选时，显示筛选条件范围内的不同时段的会话量、未回复量、留言量和访客数量统计</div>
                    <span slot="reference"><i class="el-icon-info"></i></span>
                </el-popover>
            </div>
            <lineChart v-if="Object.keys(tendencyChartData).length > 0" height="380px"
                       id="overview-service-tendency-charts"
                       :chartData="tendencyChartData"></lineChart>
        </div>
        <div class="small-chart-container">
            <div class=" publicBg">
                <p class="module-item-title-border-left">首次响应时间</p>
                <div id="overview-response-time-charts" style="height: 480px;width: 100%;"></div>
                <!--                <pieChart height="480px" chartTitle="首次响应时间"-->
                <!--                          id="overview-response-time-charts"-->
                <!--                          v-if="Object.keys(firstRespondChartData).length > 0"-->
                <!--                          :chartData="firstRespondChartData" />-->
                <!--                <div v-else class="pie-chart-nodata"> 暂无相关数据</div>-->
            </div>
            <div class=" publicBg">
                <p class="module-item-title-border-left">会话时长</p>
                <div id="overview-chat-time-charts" style="height: 380px;width: 100%;"></div>
            </div>
        </div>
        <div class="small-chart-container">
            <div class=" publicBg">
                <p class="module-item-title-border-left">满意度</p>
                <div id="overview-satisfaction-report-charts" style="height: 380px;width: 100%;"></div>
            </div>
            <div class=" publicBg">
                <p class="module-item-title-border-left">留言解决率</p>
                <div id="overview-leavewords-solve-charts" style="height: 380px;width: 100%;"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import lineChart from '@/components/echarts/line-charts'
    import pieChart from '@/components/echarts/pie-charts'
    import echarts from "echarts";

    export default {
        name: 'report-overview',
        components: {
            lineChart,
            pieChart,
        },
        data() {
            return {
                chart: null,
                selectTime: '',
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
                    }
                },
                chooseDate: '0',
                setDate: 'lastday',
                dateOptions: [
                    {name: '昨天', value: 'lastday'},
                    {name: '上周', value: 'lastweek'},
                    {name: '上月', value: 'lastmonth'},
                ],
                startTime: '',
                endTime: '',
                totalAnalyze: {
                    avg_time: 0,
                    call: 0,
                    leave: 0,
                    uncall: 0,
                    visitor: 0,
                },
                tendencyChartData: {},
                firstRespondChartData: {},
                callTimeChartData: {},
                leaveSolveChartData: {},
                satisfiesChartData: {},
            }
        },
        created() {
            this.initData()
        },
        mounted() {
            this.resizeCharts()
            window.addEventListener('resize', () => {
                this.resizeCharts()
            })
        },
        beforeDestroy() {
            if (!this.chart) {
                return
            }
            window.removeEventListener('resize', () => {
                this.resizeCharts()
            })
            this.chart.dispose() // 销毁
            this.chart = null
        },
        methods: {
            /**
             * 重置图表
             */
            resizeCharts() {
                setTimeout(() => {
                    if (this.chart) {
                        this.chart.resize()
                    }
                }, 350)
            },
            // 初始化饼状图表
            initPieChart() {
                this.chart = echarts.init(document.getElementById('overview-response-time-charts'))
                let chartData = this.firstRespondChartData
                let legendData = []
                let seriesData = []
                for (let key in chartData) {
                    legendData.push(key)
                    seriesData.push({
                        name: key,
                        value: chartData[key]
                    })
                }
                this.chart.setOption({
                    color: ['#fd6666', '#f2c900', '#63c756', '#4da3ff', '#8060fc'],
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : {c}%'
                    },
                    legend: {
                        left: '0',
                        top: '10',
                        orient: 'vertical',
                        data: legendData
                    },
                    series: [
                        {
                            name: this.chartTitle,
                            type: 'pie',
                            roseType: 'radius',
                            align: 'left',
                            data: seriesData,
                            animationEasing: 'cubicInOut',
                            animationDuration: 2600
                        }
                    ]
                })
            },
            // 初始化环状图表
            initCircleChart() {
                this.chart = echarts.init(document.getElementById('overview-leavewords-solve-charts'))
                let chartData = this.leaveSolveChartData
                let legendData = []
                let seriesData = []
                for (let key in chartData) {
                    legendData.push(key)
                    seriesData.push({
                        name: key,
                        value: chartData[key]
                    })
                }
                this.chart.setOption({
                    color: ['#fd6666', '#63c756'],
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : {c}%'
                    },
                    legend: {
                        left: '0',
                        top: '10',
                        orient: 'vertical',
                        data: legendData
                    },
                    series: [
                        {
                            name: this.chartTitle,
                            type: 'pie',
                            roseType: 'radius',
                            align: 'left',
                            radius: ['40%', '70%'],
                            data: seriesData,
                            animationEasing: 'cubicInOut',
                            animationDuration: 2600
                        }
                    ]
                })
            },
            // 初始化水平柱状图表
            initHorizontalBarChart() {
                this.chart = echarts.init(document.getElementById('overview-satisfaction-report-charts'))
                let chartData = this.satisfiesChartData
                let legendData = []
                let seriesData = []
                let seriesBgData = []
                for (let key in chartData) {
                    legendData.push(key)
                    seriesData.push({
                        name: key,
                        value: chartData[key].toString().replace(/%/g, '')
                    })
                    seriesBgData.push({
                        name: key,
                        value: '100'
                    })
                }
                this.chart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        formatter: '{b} : {c}%',
                        axisPointer: {
                            type: 'none',
                        }
                    },
                    xAxis: {
                        type: 'value',
                        boundaryGap: [0, 0.01],
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLabel: {
                            show: false,
                        }
                    },
                    yAxis: [
                        {
                            type: 'category',
                            data: legendData,
                            axisLine: {show: false},
                            axisTick: {show: false},
                            splitArea: {show: false},
                            splitLine: {show: false},
                        },
                        {
                            type: 'category',
                            data: legendData,
                            axisLine: {show: false},
                            axisTick: {show: false},
                            axisLabel: {show: false},
                            splitArea: {show: false},
                            splitLine: {show: false},
                        },
                    ],
                    series: [
                        //背景
                        {
                            name: this.chartTitle,
                            type: 'bar',
                            data: seriesBgData,
                            barWidth: '30',
                            yAxisIndex: 1,
                            barGap: '-100%',
                            animation: false,
                            itemStyle: {
                                normal: {
                                    // 定制显示（按顺序）
                                    color: '#eaeaea'
                                },
                                emphasis:{
                                    // 定制显示（按顺序）
                                    color: '#eaeaea'
                                }
                            },
                        },
                        {
                            name: this.chartTitle,
                            type: 'bar',
                            data: seriesData,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'right',
                                    formatter: function (params) {
                                        return params.value + "%";
                                    },
                                },

                            },
                            animation: false,
                            barWidth: '30',
                            animationEasing: 'cubicInOut',
                            animationDuration: 2600,
                            itemStyle: {
                                normal: {
                                    // 定制显示（按顺序）
                                    color: function (params) {
                                        let colorList = ['#63c756', '#fd6666', '#4da3ff'];
                                        return colorList[params.dataIndex]
                                    },
                                },
                                emphasis:{
                                    // 定制显示（按顺序）
                                    // color: function (params) {
                                    //     let colorList = ['#63c756', '#fd6666', '#4da3ff'];
                                    //     return colorList[params.dataIndex]
                                    // },
                                }
                            },
                        },

                    ]
                })
            },
            // 初始化垂直柱状图表
            initVerticalBarChart() {
                this.chart = echarts.init(document.getElementById('overview-chat-time-charts'))
                let chartData = this.callTimeChartData
                let legendData = []
                let seriesData = []
                let seriesBgData = []
                for (let key in chartData) {
                    legendData.push(key)
                    seriesData.push({
                        name: key,
                        value: chartData[key].toString().replace(/%/g, '')
                    })
                    seriesBgData.push({
                        name: key,
                        value: '100'
                    })
                }
                this.chart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        formatter: '{b} : {c}%',
                        axisPointer: {
                            type: 'none',
                        }
                    },
                    yAxis: {
                        name: "( % )", //坐标名字
                        nameLocation: "end",//坐标位置，支持start,end，middle
                        nameTextStyle: {//字体样式
                            fontSize: 12,//字体大小
                            padding: [0, 18, 8, 0],//距离坐标位置的距离
                            verticalAlign: 'top'
                        },
                        type: 'value',
                        boundaryGap: [0, 0.01],
                        max: 100,
                        axisTick: {show: false},
                        splitLine:{
                            show:false
                        }
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: legendData,
                            axisTick: {show: false},
                        },
                    ],
                    series: [
                        {
                            name: this.chartTitle,
                            type: 'bar',
                            data: seriesData,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top',
                                    formatter: function (params) {
                                        return params.value + "%";
                                    },
                                },

                            },
                            animation: false,
                            barWidth: '30',
                            animationEasing: 'cubicInOut',
                            animationDuration: 2600,
                            itemStyle: {
                                normal: {
                                    // 定制显示（按顺序）
                                    color: function (params) {
                                        let colorList = ['#63c756', '#fd6666', '#4da3ff','#f2c900','#8060fc'];
                                        return colorList[params.dataIndex]
                                    },
                                },
                            },
                        },

                    ]
                })
            },
            exportData() {
                let exportParams = {}
                if (this.setDate == '') {
                    exportParams = {
                        startTime: this.startTime,
                        endTime: this.endTime,
                    }
                } else {
                    exportParams = {
                        date: this.setDate
                    }
                }
                var params = Object.keys(exportParams).map(function (key) {
                    // body...
                    return encodeURIComponent(key) + "=" + encodeURIComponent(exportParams[key]);
                }).join("&");
                let exportUrl = process.env.VUE_APP_API_URL + '/wlapi/index/outTotalExcel?' + params
                window.open(exportUrl)
            },
            chooseTime(index, val) {
                if (this.chooseDate != index) {
                    this.chooseDate = index
                    this.setDate = val
                    this.selectTime = ''
                    this.startTime = ''
                    this.endTime = ''
                    this.$nextTick(() => {
                        this.initData()
                    })
                }

            },
            initData() {
                this.tendencyChartData = {}
                this.firstRespondChartData = {}
                this.callTimeChartData = {}
                this.leaveSolveChartData = {}
                this.satisfiesChartData = {}
                this.getReportData()
                this.getOverviewOnlineTendencyData()
                this.getOverviewFirstResponedData()
                this.getOverviewCallTimeData()
                this.getOverviewLeaveSolveData()
                this.getOverviewSatisfiesData()
            },
            /**
             * 时间选择
             */
            timeSelect() {
                if (this.selectTime) {
                    this.startTime = this.selectTime[0] / 1000
                    let endTime = this.selectTime[1] / 1000
                    this.endTime = endTime + 24 * 60 * 60 - 1
                    this.chooseDate = '-1'
                    this.setDate = ''
                } else {
                    this.startTime = ''
                    this.endTime = ''
                    this.chooseDate = '0'
                    this.setDate = 'lastday'
                }
                this.$nextTick(() => {
                    this.initData()
                })
            },
            /**
             * 数据总揽
             * */
            getReportData() {
                this.$http.getReportDataAPI({
                    startTime: this.startTime,
                    endTime: this.endTime,
                    date: this.setDate
                }).then(res => {
                    if (res.status == 1) {
                        this.totalAnalyze = res.data
                    }

                })
            },
            /**
             * 获取折线图数据
             */
            getOverviewOnlineTendencyData() {
                this.$http.getOverviewOnlineTendencyDataAPI({
                    startTime: this.startTime,
                    endTime: this.endTime,
                    date: this.setDate
                }).then(res => {
                    if (res.status == 1) {
                        let data = res.data
                        this.tendencyChartData = data
                    }

                })
            },
            /**
             * 首次响应时间
             */
            getOverviewFirstResponedData() {
                this.$http.getOverviewFirstResponedDataAPI({
                    startTime: this.startTime,
                    endTime: this.endTime,
                    date: this.setDate
                }).then(res => {
                    if (res.status == 1) {
                        let data = res.data
                        this.firstRespondChartData = data
                        this.initPieChart()
                    }
                })
            },
            /**
             * 会话时长
             */
            getOverviewCallTimeData() {
                this.$http.getOverviewCallTimeDataAPI({
                    startTime: this.startTime,
                    endTime: this.endTime,
                    date: this.setDate
                }).then(res => {
                    if (res.status == 1) {
                        let data = res.data
                        this.callTimeChartData = data
                        this.initVerticalBarChart()
                    }
                })
            },
            /**
             * 留言解决率
             */
            getOverviewLeaveSolveData() {
                this.$http.getOverviewLeaveSolveDataAPI({
                    startTime: this.startTime,
                    endTime: this.endTime,
                    date: this.setDate
                }).then(res => {
                    if (res.status == 1) {
                        let data = res.data
                        let newObj = {}
                        for (let key in data) {

                            if (key == 'solve') {
                                newObj['解决'] = data[key]
                            } else {
                                newObj['未解决'] = data[key]
                            }
                        }
                        this.leaveSolveChartData = newObj
                        this.initCircleChart()
                    }
                })
            },
            /**
             * 满意度
             */
            getOverviewSatisfiesData() {
                this.$http.getOverviewSatisfiesDataAPI({
                    startTime: this.startTime,
                    endTime: this.endTime,
                    date: this.setDate
                }).then(res => {
                    if (res.status == 1) {
                        let data = res.data

                        let newObj = {
                            '好评': data['好评'],
                            '中评': data['中评'],
                            '差评': data['差评'],
                        }
                        this.satisfiesChartData = newObj
                        this.initHorizontalBarChart()
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    .report-overview {

		.total-analyze-item-icon{
			display: none!important;
		}
    }
</style>
